import groupConfig from './groupConfig'
import culeArrived from './culeArrived'
import serieCars from './serieCars'
import clueToDeal from './clueToDeal'
import areaConfig from './areaConfig'
import channelConfig from './channelConfig'
import intentionCar from './intentionCar'
import customerArea from './customerArea'
import saleQuota from './saleQuota'
import saleFunnel from './saleFunnel'
import allClues from './allClues'
import dccClueFollowUp from './dccClueFollowUp'

export default {
  groupConfig,
  culeArrived,
  serieCars,
  clueToDeal,
  areaConfig,
  channelConfig,
  intentionCar,
  customerArea,
  saleQuota,
  saleFunnel,
  allClues,
  dccClueFollowUp
}
